import React, { useState } from "react";
import { Button, Modal, Input } from "antd";
import axios from "axios";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import { useCan } from "../../../utils/permissions";

const ChatSerialNoteInput = ({ tranId, onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [serialNumber, setSerialNumber] = useState("");
  const [serialImage, setSerialImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const cookies = new Cookies();
  const token = cookies.get("token");
  const can = useCan();
  const canCreateNote = can("note", "create");
  const handleFileChange = (e) => {
    setSerialImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!serialNumber || !serialImage) {
      toast.error("Serial number and image are required");
      return;
    }

    const formData = new FormData();
    formData.append("tranId", tranId);
    formData.append("noteType", "serial_image");
    formData.append("serialNumber", serialNumber);
    formData.append("serialImage", serialImage);

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API}/note/create`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Serial note added!");
      setSerialNumber("");
      setSerialImage(null);
      setIsOpen(false);
      if (onSuccess) onSuccess(); // Trigger refresh in parent
    } catch (error) {
      toast.error("Failed to add serial note");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="button" className="ml-2" color="green" variant="solid" onClick={() => setIsOpen(true)} disabled={!canCreateNote}>
        Create Serial Note
      </Button>

      <Modal
        title="Create Serial Note"
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
      >
        <form onSubmit={handleSubmit}>
          <Input
            placeholder="Serial Number"
            value={serialNumber}
            onChange={(e) => setSerialNumber(e.target.value)}
            required
          />

          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="mt-3"
            required
          />

          <Button
            type="primary"
            htmlType="submit"
            className="mt-3"
            loading={loading}
          >
            Submit
          </Button>
        </form>
      </Modal>
    </>
  );
};

export default ChatSerialNoteInput;
